import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import router from './router'
Vue.config.productionTip = false
import "./assets/css/every.css"
import "amfe-flexible"
import { i18n } from './i18n/index.js';
import store from './store'
import Vant from "vant"
import "vant/lib/index.css"
import "@/assets/icon/iconfont.css"
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import $ from 'jquery'
// Vue.prototype.$ = $

Vue.prototype.imgurl1 = process.env.VUE_APP_IMGURL1
Vue.prototype.imgurl2 = process.env.VUE_APP_IMGURL2
Vue.use(Vant);
Vue.use(ElementUI);
import VueLazyload from 'vue-lazyload'
// Vue.use(VueLazyload) // 注册方式一，使用默认配置
Vue.use(VueLazyload, {
  preload: 1.5, // 表示lazyload元素距离底部距离百分比
  loading: require('@/images/default-cover.jpg'), // 正在加载时显示的图片路径
  error: require('@/images/default-cover.jpg'), // 图片加载失败时显示的图片路径
  attempt: 3, // 图片加载失败后重试次数，默认3
})
import VueGtag from "vue-gtag";
Vue.use(VueGtag, {
  config: { id: "G-XPE65LPVCV" }
});

import * as voicePromptFun from './utils/voicePrompt'
Vue.prototype.voicePrompt = voicePromptFun.voicePrompt  //语音提醒
const originalPush = VueRouter.prototype.push
// 重写原型上的push方法，统一处理错误信息
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
new Vue({
  router,
  store,
  i18n,
  // el: '#app',
  render: h => h(App),
}).$mount('#app')
